import React from 'react';

const Racing = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_41576)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.81731 14.1703L2.67605 11.9329C2.28717 11.1706 2.08442 10.3269 2.08442 9.47106V8.78327C2.08442 5.14527 4.98822 2.17238 8.62522 2.08686C12.1711 2.00347 15.2814 3.96136 16.8468 6.87713H9.56421C8.08091 6.87713 6.87845 8.07958 6.87845 9.56289C6.87845 10.5802 7.45321 11.5102 8.36311 11.9651L10.9933 13.2802C11.8902 13.7287 12.8793 13.9622 13.8822 13.9622H17.9107C17.8893 14.4654 17.8365 14.9669 17.7525 15.4639L17.6307 16.1847C17.4264 17.3929 16.2289 18.165 15.0441 17.8522L5.14174 15.2382C4.56843 15.0869 4.08674 14.6985 3.81731 14.1703ZM17.9216 11.1672C17.9216 10.1004 17.7379 9.07729 17.4007 8.12743H13.2309L16.178 12.7119H17.9216V11.1672ZM14.6917 12.7119H13.8822C13.0734 12.7119 12.2758 12.5236 11.5524 12.1619L8.92226 10.8468C8.43595 10.6036 8.12875 10.1066 8.12875 9.56289C8.12875 8.7701 8.77143 8.12743 9.56421 8.12743H11.7445L14.6917 12.7119ZM2.70354 14.7384L1.56228 12.5011C1.08365 11.5628 0.83412 10.5244 0.83412 9.47106V8.78327C0.83412 4.4662 4.27995 0.93839 8.59582 0.836901C14.3962 0.700505 19.1719 5.36524 19.1719 11.1672V13.4494C19.1719 14.1943 19.1095 14.9378 18.9853 15.6723L18.8635 16.3931C18.5367 18.3262 16.6206 19.5615 14.725 19.0611L4.82262 16.4471C3.90533 16.205 3.13463 15.5835 2.70354 14.7384Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_41576" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Racing };
//# sourceMappingURL=Racing.js.map
